module.exports = __webpack_public_path__ + "fonts/GothamBook.a563635d.otf";